<template>
	<div class="nav">
		<div @click="about(1)" class="nav-bg">
			<div>
				<h1 class="font-2">百年厦大</h1>
				<p class="font-3">厦门大学庆祝建校100周年形象片</p>
			</div>
		</div>
		<div @click="about(2)" class="nav-bg">
			<div>
				<h1 class="font-2">陈嘉庚与百年厦大</h1>
				<p class="font-3">
					中央广播电视总台中文国际频道<br />					“国家记忆”栏目大型纪录片
				</p>
			</div>
		</div>
		<div @click="about(3)" class="nav-bg">
			<div>
				<h1 class="font-2">南方之强</h1>
				<p class="font-3">厦门大学庆祝建校100周年文艺晚会</p>
			</div>
		</div>
		<div @click="about(4)" class="nav-bg">
			<div>
				<h1 class="font-2">凤凰花季</h1>
				<p class="font-3"><font>歌</font>曲</p>
			</div>
		</div>
		<div @click="about(5)" class="nav-bg">
			<div>
				<h1 class="font-2">相聚在美丽的校园</h1>
				<p class="font-3"><font>歌</font>曲</p>
			</div>
		</div>
	</div>
</template>
<script>
export default{
	name: 'jm-nav',
	methods: {
		about(index){
			this.$router.push({ path:'/About/' + index + '.html'});
		}	
	}
}
</script>
<style scoped>
.nav{
	display: flex;
	width: 68rem;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 2rem;
}
.nav .nav-bg{
	background: #d7412a;
	width: 12.8rem;
	height: 3.55rem;
	cursor: pointer;
	border-radius: .15rem;
	padding: .25rem;
}
.nav .nav-bg div{
	border:1px solid #c6af7b;
	border-radius: .15rem;
	width: 100%;
	height: 100%;
}
.nav h1{
	color: #c6af7b;
	font-size: 1.8rem;
	text-align: center;
}
.nav p{
	color: #c6af7b;
	text-align: center;
	font-size: .75rem;
}
.nav .nav-bg:nth-child(2) h1{
	font-size: 1.4rem;
	margin-top: -.1rem;
}
.nav .nav-bg:nth-child(2) p{
	font-size: .7rem;
	line-height: .8rem;
}
.nav .nav-bg:nth-child(5) h1{
	font-size: 1.45rem;
}
.nav .nav-bg:nth-child(5) p{
	margin-top: .25rem;
}
.nav font{
	margin-right: 1rem;
	font-size: .75rem;
}
</style>